const hasElement = selector => Boolean(document.querySelector(selector))

export default hasElement
